document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    // Delegate so widgets re-rendered by the tab swap still work.
    page.addEventListener('click', (e) => {
        const trigger = e.target.closest('.myaccount__select-trigger');
        const option  = e.target.closest('.myaccount__option');

        // 1) Trigger click — open / close
        if (trigger) {
            const select = trigger.closest('.myaccount__custom-select');
            if (!select) return;
            if (select.dataset.disabled === 'true') return;

            e.stopPropagation();
            page.querySelectorAll('.myaccount__custom-select.open').forEach((s) => {
                if (s !== select) s.classList.remove('open');
            });
            select.classList.toggle('open');
            return;
        }

        // 2) Option click — select value
        if (option) {
            const select = option.closest('.myaccount__custom-select');
            if (!select || select.dataset.disabled === 'true') return;

            e.stopPropagation();
            const value  = option.getAttribute('data-value') || '';
            const label  = option.textContent.trim();
            const span   = select.querySelector('.myaccount__select-trigger span');
            const hidden = select.querySelector('input[type="hidden"]');

            if (span)   span.textContent = label;
            if (hidden) {
                hidden.value = value;
                // Programmatic value changes don't fire a native change event;
                // dispatch one so inline-validation error clearing can react.
                hidden.dispatchEvent(new Event('change', { bubbles: true }));
            }

            select.querySelectorAll('.myaccount__option').forEach((o) => o.classList.remove('selected'));
            option.classList.add('selected');
            select.classList.remove('open');
        }
    });

    // Click outside any select closes them all.
    document.addEventListener('click', (e) => {
        if (e.target.closest('.myaccount__custom-select')) return;
        page.querySelectorAll('.myaccount__custom-select.open').forEach((s) => s.classList.remove('open'));
    });
});
